/**
 * @generated SignedSource<<5b68c474a792e672c8a6a0b8b58c8645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type issuesDropdownNewsletterArticleArticleConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entityId: string;
      readonly entityUuid: string;
      readonly publishedDate: number | null | undefined;
      readonly urlAlias: string;
    };
  }>;
  readonly " $fragmentType": "issuesDropdownNewsletterArticleArticleConnection";
};
export type issuesDropdownNewsletterArticleArticleConnection$key = {
  readonly " $data"?: issuesDropdownNewsletterArticleArticleConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"issuesDropdownNewsletterArticleArticleConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "issuesDropdownNewsletterArticleArticleConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Article",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityUuid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publishedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlAlias",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleConnection",
  "abstractKey": null
};

(node as any).hash = "7126eeb595488d42a44fc066b44f02a8";

export default node;
